import { Image } from "@components/Image/Image";
import { Video } from "@components/Video/Video";
import React, { forwardRef } from "react";
import tw, { styled } from "twin.macro";
import { ImageZoom } from "./ImageZoom";
import { Badge } from "./Images";
import { ImagesOutputProps } from "./withImages";

const ImageZoomer = styled(ImageZoom)`
  ${tw`aspect-12-13`}
`;
const Container = styled.div`
  ${tw`relative`}
  height: ${({ height }) => (height ? `${height}px` : "auto")};
`;
const ImageWrapper = tw.div`
  absolute aspect-12-13 w-full bg-white bg-opacity-60
`;
const ImageContainer = styled.div`
  ${tw`absolute w-full transition-opacity ease-cubic motion-reduce:transition-none`}
  ${({ active }) => (active ? tw`z-10 opacity-100` : tw`opacity-0`)}
`;
const VideoWrapper = styled.div`
  ${tw`absolute w-full h-full focus:outline-none`}
  ${({ active }) => (active ? tw`z-10 opacity-100` : tw`opacity-0`)}
`;
const VideoContainer = tw.div`
  w-full aspect-12-13 relative
`;
const VideoInner = tw.div`
  absolute inset-0 w-full h-full
`;

export const DesktopImages = forwardRef<HTMLElement, ImagesOutputProps>(
  (
    { badge, images, height, slideIndex, video }: ImagesOutputProps,
    containerRef,
  ) => {
    return (
      <Container height={height}>
        <ImageWrapper>
          {badge && (
            <Badge sale={badge?.name?.toLowerCase() === `sale`} {...badge}>
              {badge?.name}
            </Badge>
          )}
          {images?.map((image, index) => {
            if (image?.isCoverImage && !!video?.url) {
              return (
                <VideoWrapper key={image._id} active={index === slideIndex}>
                  <VideoContainer>
                    <VideoInner data-testid="desktop-images-video-player">
                      <Video video={video} playing={true} />
                    </VideoInner>
                  </VideoContainer>
                </VideoWrapper>
              );
            }
            return (
              <ImageContainer
                key={image._id}
                ref={containerRef}
                active={index === slideIndex}
              >
                <ImageZoomer src={image.src || image.url} ratio="12/13">
                  <Image
                    image={image.src || image.url}
                    alt={image.alt}
                    srcSet={image.srcSet}
                    ratio="12/13"
                    maxWidth={1000}
                  />
                </ImageZoomer>
              </ImageContainer>
            );
          })}
        </ImageWrapper>
      </Container>
    );
  },
);
